/**
 * Constants for Privacy calculations
 * Source: Plantilla ARI+RAT addval v1.1
 */

/**
 * Risk level thresholds and labels
 */
export const RISK_LEVELS = {
  LOW: { min: 1, max: 4, label: 'Bajo' },
  MEDIUM: { min: 5, max: 9, label: 'Medio' },
  HIGH: { min: 10, max: 14, label: 'Alto' },
  VERY_HIGH: { min: 15, max: 19, label: 'Muy Alto' },
  CRITICAL: { min: 20, max: 25, label: 'Crítico' },
}

/**
 * Maps risk score to risk level
 * @param {number} risk - Risk score (1-25)
 * @returns {string|null} Risk level label or null
 */
export function getRiskLevel(risk) {
  if (risk == null || isNaN(risk)) return null

  if (risk >= RISK_LEVELS.CRITICAL.min && risk <= RISK_LEVELS.CRITICAL.max) return RISK_LEVELS.CRITICAL.label
  if (risk >= RISK_LEVELS.VERY_HIGH.min && risk <= RISK_LEVELS.VERY_HIGH.max) return RISK_LEVELS.VERY_HIGH.label
  if (risk >= RISK_LEVELS.HIGH.min && risk <= RISK_LEVELS.HIGH.max) return RISK_LEVELS.HIGH.label
  if (risk >= RISK_LEVELS.MEDIUM.min && risk <= RISK_LEVELS.MEDIUM.max) return RISK_LEVELS.MEDIUM.label
  if (risk >= RISK_LEVELS.LOW.min && risk <= RISK_LEVELS.LOW.max) return RISK_LEVELS.LOW.label

  return null
}

/**
 * Control effectiveness multipliers for residual risk calculation
 * Source: Plantilla ARI+RAT addval v1.1
 */
export const EFFECTIVENESS_MULTIPLIERS = {
  1: 1.0, // Nula
  2: 0.8, // Baja
  3: 0.5, // Media
  4: 0.2, // Alta
  5: 0.05, // Muy Alta
}

/**
 * Gets multiplier for given effectiveness level
 * @param {number} effectiveness - Effectiveness level (1-5)
 * @returns {number} Multiplier
 */
export function getEffectivenessMultiplier(effectiveness) {
  return EFFECTIVENESS_MULTIPLIERS[effectiveness] ?? 1.0
}

/**
 * EIPD (DPIA) threshold configuration
 * Source: Plantilla ARI+RAT addval v1.1
 */
export const EIPD_CONFIG = {
  MIN_FACTOR_SCORE: 3, // Minimum score for EIPD factor to trigger requirement
  MIN_AVG_SCORE: 3, // Minimum average score for EIPD factors
}

/**
 * Factor types for risk calculation
 */
export const FACTOR_TYPES = {
  PROBABILITY: 'probability',
  IMPACT: 'impact',
  EIPD: 'eipd',
}

/**
 * NA value indicator
 */
export const NA_VALUE = null
